import { useTaskSyncFreshness } from '../../hooks/useClients';
import { SyncStalenessBanner } from './SyncStalenessBanner';

/**
 * The sync banner for any page whose numbers come from the CRM mirror (SUP-PROD-03, "provenance beyond one page").
 * It used to appear on Clients only, while the Dashboard, Bookkeeping, Workload, Team Performance, Reviews and a
 * client's page showed the same mirror's counts with nothing to say they were behind.
 *
 * It reads the freshness the clients list already carries (same query key, so on a page that loads that list it costs
 * nothing), and says nothing until it knows: SyncStalenessBanner renders only when the mirror is actually stale.
 * `scripts/mirror-freshness-pages.test.mjs` names the pages that must render it.
 */
export function MirrorFreshnessBanner() {
  const { data } = useTaskSyncFreshness();
  return <SyncStalenessBanner freshness={data} />;
}
